export const emailValid = email => {
	let re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	return re.test(String(email).toLowerCase());
}

export const dateValid = date => {
	let re = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
	return re.test(date);
}

export const phoneValid = phone => {
	let re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}/;
	return re.test(phone);
}

// YouTube split address
// export const YouTubeGetID = url => {
// 	url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
// 	return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_-]/i)[0] : url[0];
// }


// WEBPACK FOOTER //
// ./src/utils/index.js